import { FC } from "react";
import styles from "../Pricing.module.scss";

const Banner: FC = () => {
    return (
        <div className={styles.banner}>
            <div className={styles.text}>
                <span className={styles.subtitle}>Pricing</span>
                <h1 className={styles.headline}>
                    <span>Choose your plan</span>
                </h1>
                <p className={styles.description}>
                    We have made flexible plans for your tasks. Choose what suits you best.
                </p>
            </div>
        </div>
    );
};

export default Banner;
